import { gql } from './types/generated/gql';

export const GENERATE_PLAYBACK_URLS = gql(`
  mutation generatePlaybackUrls($mediaIds: [String!]!) {
    generatePlaybackUrls(mediaIds: $mediaIds) {
      playbacks {
        url
        cdn
        token
        expiration
        adsEnabled
        adExperienceType
        priority
        adEngineIdentifiers {
          name
          value
        }
        features
      }
    }
  }
`);

export const ASSIGN_TARGETS = gql(`
  mutation assignTargets($targetChanges: [TargetChangeInput!]!) {
    assignTargets(targetChanges: $targetChanges) {
      success
      reason
      channelId
      target {
        id
        type
      }
    }
  }
`);
